<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-07 19:15:57
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-07 19:26:36
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/local/tableCells/tagCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<rd-tag-group :list="(row.tagList && row.tagList.map(item => item.tagName)) || []" :max="2" :canEdit="false"></rd-tag-group>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	components: {},
	computed: {},
	props: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped></style>
